<template>
  <v-container id="crm" fluid>
    <v-layout wrap>
      <v-flex xs12 sm4>
        <h3 class="title">{{ $t('Customer') }}</h3>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <v-btn outline loading color="grey"></v-btn>
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
            <v-btn color="grey" outline>
              <em class="fas fa-file-import" />
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <em class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" :disabled="delayImport" outline @click="importCustomer">
              <em class="fas fa-file-import" />
              &nbsp;
              {{ $t('Import') }}
            </v-btn>
            <v-btn color="grey" outline @click="onExportCustomer()">
              <em class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}
            </v-btn>
          </template>
        </template>

        <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <em v-if="!showAdvance" class="fas fa-angle-down" />
          <em v-else class="fas fa-angle-up" />
        </v-btn>
      </v-flex>
    </v-layout>
    <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <template>
        <v-premium-plan-popup
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          :show-all="false"
          margin-top="65"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <filter-customer v-model="filter" :total_user="total_user">
          <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed color="primary" @click="onSearch">
            <em class="fas fa-search mr-1" />
            {{ $t('Search') }}
          </v-btn>

          <div v-if="selectedBot.theme == 'hafele'" slot="append" slot-scope="{ filter }">
            <v-divider class="mt-2"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp ID') }}</label>
                <input
                  v-model="filter.emp_id"
                  type="text"
                  :placeholder="$t('Emp ID')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  v-model="filter.emp_first_name"
                  type="text"
                  :placeholder="$t('Emp First Name')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  v-model="filter.emp_last_name"
                  type="text"
                  :placeholder="$t('Emp Last Name')"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
            </v-layout>
          </div>
        </filter-customer>
      </template>
    </div>
    <v-pagination
      v-model="pageNumber"
      :total-visible="15"
      :length="pagelength"
      @input="changePage"
    ></v-pagination>
    <v-layout row wrap>
      <v-flex xs6></v-flex>
      <v-flex xs6>
        <div class="ma-2 text-xs-right">
          <span class="caption mr-2">{{ $t('Total') }}</span>

          <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
            total_user | numberFormat
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="loading"
      :headers="filteredHeader"
      :items="users"
      class="elevation-1"
      :pagination.sync="pagination"
      hide-actions
    >
      <template #items="props">
        <customer-item v-model="props.item"></customer-item>
      </template>

      <div slot="no-data" class="text-xs-center">{{ $t('No customer') }}</div>
    </v-data-table>

    <div class="mt-4">
      <v-pagination
        v-model="pageNumber"
        :total-visible="15"
        :length="pagelength"
        @input="changePage"
      ></v-pagination>
    </div>

    <v-dialog v-model="showExport" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showExport = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <template v-for="page in exportpagecount">
              <v-flex :key="`expor_${page}`" xs6 sm4 md3 class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large>folder_shared</v-icon>
                  <div class="caption">
                    {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                    <template v-if="page == exportpagecount">
                      {{ total_user | numberFormat }}
                    </template>
                    <template v-else>{{ (page * exportlimit) | numberFormat }}</template>
                  </div>
                  <v-btn
                    small
                    color="primary"
                    depressed
                    @click="exportCustomer((page - 1) * exportlimit)"
                    >download</v-btn
                  >
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import CustomerItem from '../customer/CustomerItem'
import { mapGetters } from 'vuex'
import FilterCustomer from '@/components/elements/FilterCustomer'
import * as XLSX from 'xlsx'

export default {
  components: {
    CustomerItem,
    FilterCustomer
  },
  data: function () {
    var headers = []
    // console.log(this.$store.state.selectedBot)

    if (this.$store.state.selectedBot.theme == 'hafele') {
      headers.push({ text: this.$t('ID'), value: 'emp_id' })
    }

    headers = headers.concat([
      { text: '', sortable: false },
      { text: this.$t(''), value: '' },
      { text: this.$t('name'), value: 'first_name' },
      { text: this.$t('Store ID'), value: 'shop_id' },
      { text: this.$t('Channel'), value: 'app' },
      { text: this.$t('gender'), value: 'gender' },
      { text: this.$t('Register Date'), value: 'registertimestamp' },
      { text: this.$t('Last Active Date'), value: 'timestamp' },
      { text: this.$t('Email'), value: 'email' },
      { text: this.$t('phone no.'), value: 'phoneno' },
      { text: this.$t('Status'), value: 'status' },
      { text: this.$t('Message Sent'), value: 'messagesent' },
      { text: this.$t('Locale'), value: 'locale' },
      { text: this.$t('Lineid'), value: 'lineid' },
      { text: this.$t('Province'), value: 'province' },
      { text: this.$t('School'), value: 'school' },
      { text: '', sortable: false }
    ])

    return {
      customertype: '',
      headers: headers,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      delayImport: false,
      search: '',
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: ''
      },
      loading: true,
      errorFilterTag: [],
      pagetmp: 1,
      errorFilterStatus: [],
      customerfromfb: null,
      total_user: '',
      exportlimit: 5000,
      showExport: false,
      exportpagecount: 0
    }
  },

  computed: {
    pagelength() {
      if (this.total_user) {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filteredHeader() {
      if (this.isBU) return this.headers
      else {
        return this.headers.filter((v) => {
          return !['lineid', 'province', 'school'].includes(v.value)
        })
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },

    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function (s) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (s) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  watch: {
    count: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  },
  mounted: async function () {
    var vm = this

    vm.loading = true
    vm.getLoadUsers(vm.limit, vm.offset).then(
      function (users) {
        vm.offset += vm.limit
        vm.users = vm.users.concat(users)
        vm.loading = false
      },
      function () {
        vm.loading = false
      }
    )

    vm.$store.dispatch('loadStatus')
    // this.estimateReach({ pageid: vm.pageid })
  },
  methods: {
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        vm.pageloading = true
        this.getMoreCustomers()
      }
    },
    estimateReach: function (data) {
      var vm = this

      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.data) {
          vm.total_user = response.data.total
        }
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    clearSearch: function () {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function () {
      var vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        vm.getLoadUsers(vm.limit, vm.offset).then(
          function (users) {
            vm.users = users
            vm.loading = false
          },
          function (error) {
            console.error(error)
            vm.loading = false
          }
        )
      })
    },
    collectexportcustomersanalytic() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        grouptype: vm.grouptype,
        filter: vm.filter,
        limit: vm.limit,
        offset: vm.offset
      }

      api.collectexportcustomersanalytic(data, function (error) {
        if (error) {
          console.error(error)

          return
        }
      })
    },
    getLoadUsers: function (limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter,
          limit: limit,
          offset: offset
        }
        // vm.estimateReach(data)

        api.getAllUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.total_user = response.count
          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          vm.total_user = response.count
          resolve(users)
        })
      })
    },
    getMoreCustomers: function () {
      var vm = this
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function (users) {
          vm.offset += vm.limit
          vm.users = users
          vm.loading = false
        },
        function (error) {
          console.error(error)
          vm.loading = false
        }
      )
    },
    onFailLoad: function (index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    exportCustomer: function (offset = 0) {
      let vm = this
      let csvContent = ''
      var json = []

      var limit = 5000
      vm.loading = true
      // let locale = config.locale.find(function(locales) {
      //   if (val.locale == locales.value) {
      //     return true
      //   }
      // })
      vm.getLoadUsers(limit, offset).then(
        function (users) {
          if (users && users.length > 0) {
            csvContent += 'ID,'
            if (vm.selectedBot.theme == 'hafele') {
              csvContent += 'Emp ID,'
            }
            csvContent += 'Name,Channel,Gender,Register Date,Last Active Date'
            if (vm.$store.getters.getPackage == 'premium') {
              csvContent += ',Email,Phone No,Status,Tag,Message Sent'
            }

            csvContent += ',Locale'

            if (vm.$store.getters.getPackage == 'premium') {
              csvContent += ',Intent'
            }

            csvContent += '\r\n'

            $.each(users, function (index, val) {
              let row = ''
              if (vm.$store.getters.getPackage == 'premium') {
                row += '"' + (val.id ? val.id : '-') + '",'
              } else {
                row += '"premium",'
              }
              if (vm.selectedBot.theme == 'hafele') {
                row += '="' + (val.emp_id ? val.emp_id.replace(/\r?\n|\r/g, ' / ') : '-') + '",'
              }

              row +=
                '"' +
                (
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : '')
                ).replace(/\r?\n|\r/g, ' / ') +
                '",'
              row += '"' + val.app + '",'
              row += '"' + val.gender + '",'
              row +=
                '"' +
                (val.registertimestamp ? moment(val.registertimestamp).format('DD/MM/YYYY') : '-') +
                '",'
              row += '"' + (val.timestamp ? moment(val.timestamp).format('DD/MM/YYYY') : '-') + '",'
              if (vm.$store.getters.getPackage == 'premium') {
                row += '"' + (val.email ? val.email : '').replace(/\r?\n|\r/g, ' / ') + '",'
                row +=
                  (val.phoneno ? '="' + val.phoneno.replace(/\r?\n|\r/g, ' / ') + '"' : '""') + ','
                row += '"' + (val.status ? val.status : '').replace(/\r?\n|\r/g, ' / ') + '",'
                row += '"' + (val.tags ? val.tags : '').replace(/\r?\n|\r/g, ' / ') + '",'
                row += '"' + (val.messagesent ? val.messagesent : '') + '",'
              }
              row += '"'
              var locale = config.locale.find(function (locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : this.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }

              let tempJson = {
                pageuid: userid_split,
                'Social Name':
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : ''),
                Channel: val.app,
                Gender: val.gender,
                'Register Date': val.registertimestamp
                  ? moment(val.registertimestamp).format('DD/MM/YYYY')
                  : '-',
                'Last Active Date': val.timestamp
                  ? moment(val.timestamp).format('DD/MM/YYYY')
                  : '-',
                Email:
                  vm.$store.getters.getPackage == 'premium'
                    ? val.email
                      ? val.email
                      : ''
                    : this.$t('premium'),
                'Phone No':
                  vm.$store.getters.getPackage == 'premium' ? val.phoneno : this.$t('premium'),
                Status: vm.$store.getters.getPackage == 'premium' ? val.status : this.$t('premium'),

                'Message Sent':
                  vm.$store.getters.getPackage == 'premium' ? val.messagesent : this.$t('premium'),
                Locale: locale ? locale : '',
                Intent:
                  vm.$store.getters.getPackage == 'premium'
                    ? val.intentlist
                      ? val.intentlist.join(',')
                      : ''
                    : this.$t('premium'),
                Note: vm.$store.getters.getPackage == 'premium' ? val.temp_msg : this.$t('premium')
              }

              if ([...vm.$store.state.toaPaintPage].includes(vm.selectedBot.pageid)) {
                if (val.tags) {
                  let arrTags = val.tags.split(',') || []
                  let tempTags = {}

                  arrTags.forEach((tag, index) => {
                    let key = `Tag${index + 1}`
                    Object.assign(tempTags, { [key]: tag })
                  })
                  Object.assign(tempJson, tempTags)
                }
              } else {
                Object.assign(tempJson, {
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : this.$t('premium')
                })
              }

              json.push(tempJson)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const csv = XLSX.utils.sheet_to_csv(dataWS)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            // function s2ab(s) {
            //   // var buf = new ArrayBuffer(s.length)
            //   // var view = new Uint8Array(buf)
            //   // for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
            //   return Buffer.from(s, 'utf8')
            // }

            // saveAs(
            //   new Blob(['\uFEFF' + s2ab(csv)], { type: 'text/csv; charset=utf-18' }),
            //   'zwiz-customer.csv'
            // )

            // offset += limit
            // if (users.length >= limit) {
            //   vm.exportCustomer(offset)
            // } else {
            //   vm.loading = false
            // }
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function () {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    onExportCustomer() {
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)
      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        this.exportCustomer(0)
      }
    },
    importCustomer: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, async function (error, response) {
              if (error) {
                vm.loading = false
                return
              }
              if (response.responsecode == 200) {
                api.insertUsersFromDone(data, function () {
                  vm.getLoadUsers(vm.limit, vm.offset).then(
                    function (users) {
                      vm.users = vm.users.concat(users)

                      vm.delayImport = true
                      vm.$swal.fire({
                        title: vm.$t('Import customer successful'),
                        type: 'success',
                        confirmButtonText: vm.$t('Confirm'),
                        cancelButtonText: vm.$t('cancel'),
                        reverseButtons: true
                      })
                      vm.loading = false
                    },
                    function (error) {
                      console.error(error)
                      vm.loading = false
                    }
                  )
                })
              }
            })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/ToaCustomer.vue